/* HappyDic — global storefront behaviors: cart drawer (AJAX), qty steppers,
   size selector, mobile nav. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  /* ---------- Money formatting (mirrors Shopify.formatMoney) ---------- */
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(num, precision) {
      num = (num / 100).toFixed(precision === undefined ? 2 : precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      return dollars + (parts[1] ? '.' + parts[1] : '');
    }
    var match = moneyFormat.match(placeholder);
    var fmt = match ? match[1] : 'amount';
    switch (fmt) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2); break;
      default: value = defaultTo(cents, 2);
    }
    return moneyFormat.replace(placeholder, value);
  }
  window.HappyDic = window.HappyDic || {};
  window.HappyDic.formatMoney = formatMoney;

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  window.HappyDic.openCart = openDrawer;
  window.HappyDic.closeCart = closeDrawer;

  function lineArt(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x150$1$2') + '" alt="" />' : '';
    return img;
  }

  function updateShipBar(total) {
    var threshold = (window.theme && window.theme.freeShipThreshold) || 7500;
    document.querySelectorAll('[data-shipbar]').forEach(function (bar) {
      var msg = bar.querySelector('[data-shipbar-msg]');
      var fill = bar.querySelector('[data-shipbar-fill]');
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        msg.innerHTML = total >= threshold
          ? 'You’ve unlocked <strong>free shipping</strong> 🎉'
          : 'You’re <strong>' + formatMoney(threshold - total) + '</strong> away from free shipping';
      }
      bar.classList.toggle('is-complete', total >= threshold);
    });
  }
  window.HappyDic = window.HappyDic || {};
  window.HappyDic.updateShipBar = updateShipBar;

  function renderCart(cart) {
    if (!drawer) return;
    // count badge(s)
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? '' : 'none';
    });
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
    if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;
    updateShipBar(cart.total_price);

    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>GAME OVER<br>CART IS EMPTY</p></div>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item) {
      var size = '';
      if (item.options_with_values && item.options_with_values.length) {
        size = item.options_with_values.map(function (o) { return o.value; }).join(' / ');
      }
      return '' +
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<div class="cart-line__art">' + lineArt(item) + '</div>' +
          '<div class="cart-line__main">' +
            '<div class="cart-line__top">' +
              '<span class="cart-line__name">' + item.product_title + '</span>' +
              '<button class="cart-line__remove" data-remove aria-label="Remove">\u2715</button>' +
            '</div>' +
            (size ? '<span class="cart-line__size">' + size + '</span>' : '') +
            '<div class="cart-line__row">' +
              '<div class="hd-qty hd-qty--sm">' +
                '<button data-qty-dec aria-label="Decrease">\u2013</button>' +
                '<span class="hd-qty__val">' + item.quantity + '</span>' +
                '<button data-qty-inc aria-label="Increase">+</button>' +
              '</div>' +
              '<span class="hd-price hd-price--sm"><span class="hd-price__amt">' + formatMoney(item.final_line_price) + '</span></span>' +
            '</div>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
  }
  function addVariant(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      return fetchCart().then(function (cart) { renderCart(cart); openDrawer(); return cart; });
    });
  }
  window.HappyDic.addVariant = addVariant;

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-open]')) { e.preventDefault(); fetchCart().then(renderCart).then(openDrawer); return; }
    if (t.closest('[data-cart-close]') || t.classList.contains('cart-drawer__scrim')) { closeDrawer(); return; }
    if (t.closest('[data-nav-toggle]')) { document.body.classList.toggle('nav-open'); return; }

    // drawer line controls
    var line = t.closest('[data-line-key]');
    if (line) {
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('.hd-qty__val');
      var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (t.closest('[data-remove]')) { changeLine(key, 0); return; }
      if (t.closest('[data-qty-dec]')) { changeLine(key, Math.max(0, cur - 1)); return; }
      if (t.closest('[data-qty-inc]')) { changeLine(key, cur + 1); return; }
    }

    // PDP / form qty steppers (data-qty-form)
    var stepper = t.closest('[data-qty-stepper]');
    if (stepper) {
      var input = stepper.querySelector('input[type="number"], [data-qty-input]');
      if (input) {
        var v = parseInt(input.value || '1', 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var max = parseInt(input.getAttribute('max') || '99', 10);
        if (t.closest('[data-qty-dec]')) v = Math.max(min, v - 1);
        if (t.closest('[data-qty-inc]')) v = Math.min(max, v + 1);
        input.value = v;
        var label = stepper.querySelector('.hd-qty__val');
        if (label) label.textContent = v;
      }
    }

    // PDP size tags
    var sizeBtn = t.closest('[data-size]');
    if (sizeBtn && !sizeBtn.disabled) {
      var form = sizeBtn.closest('form');
      form.querySelectorAll('[data-size]').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      sizeBtn.classList.add('is-selected'); sizeBtn.setAttribute('aria-pressed', 'true');
      var variantId = sizeBtn.getAttribute('data-variant-id');
      var hidden = form.querySelector('[data-variant-input]');
      if (hidden && variantId) hidden.value = variantId;
      var addBtn = form.querySelector('[data-add-btn]');
      var soldOut = sizeBtn.getAttribute('data-available') === 'false';
      if (addBtn) {
        addBtn.disabled = soldOut;
        addBtn.querySelector('[data-add-label]') && (addBtn.querySelector('[data-add-label]').textContent = soldOut ? 'Sold out' : 'Add to cart');
      }
    }
  });

  /* ---------- PDP add-to-cart (AJAX with graceful fallback) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var idInput = form.querySelector('[data-variant-input]');
      if (!idInput || !idInput.value) return; // let native submit / show error
      e.preventDefault();
      var qtyInput = form.querySelector('[data-qty-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var btn = form.querySelector('[data-add-btn]');
      if (btn) btn.disabled = true;
      addVariant(idInput.value, qty).then(function () {
        if (btn) btn.disabled = false;
      }).catch(function () {
        form.submit(); // fall back to /cart
      });
    });
  });

  /* ---------- Grid "Add" quick-add buttons ---------- */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    var id = quick.getAttribute('data-quick-add');
    if (!id) { window.location.href = quick.getAttribute('href') || '#'; return; }
    quick.disabled = true;
    addVariant(id, 1).then(function () { quick.disabled = false; });
  });

  // Initialize the free-shipping bar from the server-rendered cart total on load.
  updateShipBar((window.theme && window.theme.cartTotal) || 0);

})();

/* ---------- Size guide modal ---------- */
(function () {
  function close() {
    var sg = document.querySelector('[data-size-guide]');
    if (sg) { sg.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-size-guide-trigger]')) {
      var sg = document.querySelector('[data-size-guide]');
      if (sg) { sg.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-size-guide-close]') || e.target.classList.contains('sizeguide__scrim')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* ---------- Product recommendations (Section Rendering API) ---------- */
(function () {
  var el = document.querySelector('[data-product-recommendations]');
  if (!el || !el.getAttribute('data-url')) return;
  fetch(el.getAttribute('data-url'))
    .then(function (r) { return r.text(); })
    .then(function (text) { if (text.indexOf('product-card') !== -1) el.innerHTML = text; })
    .catch(function () {});
})();
